import React from 'react';
import { XIcon } from 'lucide-react';
const pains = ['Twelve players lined up for one drill — two hitting, ten watching', 'First-timers and 3.5s on the same court, and you splitting your attention between them', 'An hour before class and you’re still deciding what to teach', 'Not sure what the first three lessons should cover — or in what order', 'Rotations that turn into confusion the moment the group gets bigger', 'Hours of free drill videos that never add up to an actual session', 'New players feeling lost while the stronger ones get bored', 'Two people show up — or sixteen — and the plan falls apart'];
export function PainGrid() {
  return <section aria-labelledby="pain-heading" className="w-full bg-navy-deep" data-id="element-157" data-mp="17o93a25nkjsp">
      <div className="max-w-5xl mx-auto px-5 py-16 sm:py-20" data-id="element-158" data-mp="17qc31dwlxram">
        <div className="text-center" data-id="element-159" data-mp="362u9ejfhpqsn">
          <p className="text-[11px] font-bold uppercase tracking-[1.6px] text-gold" data-id="element-160" data-mp="361rgk5ylxea3">
            The coaching reality
          </p>
          <h2 id="pain-heading" className="mt-3 font-display font-bold uppercase text-white text-3xl sm:text-4xl md:text-5xl leading-tight" data-id="element-161" data-mp="3g9d542by2g1w">
            If you coach pickleball, you know at least{' '}
            <span className="text-crimson-soft" data-id="element-162" data-mp="379q95w1zi2g8">half of this list.</span>
          </h2>
        </div>

        <ul className="mt-9 grid gap-3 text-left sm:grid-cols-2 sm:gap-x-5" data-id="element-163" data-mp="3bas4i1ss5ucx">
          {pains.map(pain => <li key={pain} className="flex items-start gap-3 rounded-xl border border-navy-line bg-navy-card px-4 py-4 text-sm text-white/85" data-id="element-164" data-mp="2uyve80s3l5w">
              <span className="mt-0.5 flex h-5 w-5 flex-none items-center justify-center rounded-full bg-crimson/20" data-id="element-165" data-mp="3q6hnrs6kztdy">
                <XIcon className="h-3 w-3 text-crimson-soft" aria-hidden="true" data-id="element-166" data-mp="3u71kwvr5mx03" />
              </span>
              {pain}
            </li>)}
        </ul>

        <p className="mt-9 text-center font-display uppercase text-2xl sm:text-3xl text-gold leading-tight" data-id="element-167" data-mp="qkt6ol5g91o1">
          How many more sessions with half the group on the sidelines?
        </p>
      </div>
    </section>;
}